import { createAction, props } from '@ngrx/store';

export const focusElement = createAction('[Creatives] Focus element', props<{ elementId: string }>());

export const blurElement = createAction('[Creatives] Blur element');
